<template>
    <div class="container">

        <div class="common-header-wrap">
            <mt-header :title="$t('MyTeam')" class="common-header" ref="header" :style="headerStyle">
                <div slot="left" class="lang" @click="setLang">
                    <img src="../../../assets/image/lang.png" alt="">
                </div>
                <mt-button slot="right" @click="logout">{{ $t('Log Out') }}</mt-button>
            </mt-header>
        </div>

        <div class="tabss">
            <div class="tabb" v-for="(item, index) in tabs" :key="index" :class="{ activee: index === activeTab }"
                @click="tabClickk(item, index)">{{ $t(item.gc_name) }}</div>
        </div>

        <div class="center" v-if="other">
            <div class="huiyuan">
                <div class="hitem">
                    <div class="k">{{ $t('number_of_people') }}</div>
                    <div class="v">{{ activeTab == 0 ? other.member_ids.length : other.member_count }}</div>
                </div>
                <div class="hitem">
                    <div class="k">{{ $t('amount') }}</div>
                    <div class="v">{{ other.total_price }}</div>
                </div>
            </div>
        </div>

        <div class="search">
            <div class="l">
                <div class="icon">
                    <img src="../../../assets/image/home/Search.png" alt="">
                </div>
                <input type="text" v-model="keyword" :placeholder="$t('enter_username_id_to_search')"
                    @keyup.enter="handleEnter" />
            </div>
            <div class="search1 button" @click="handleEnter">{{ $t('Search') }}</div>
        </div>

        <div class="tit">
            <div class="l">
                {{ $t('team_list') }}
            </div>

            <div class="r" @click="open">{{ $t('filter') }}></div>
        </div>

        <div class="tabs">
            <div class="tab" :class="{ active: indexe == current }" v-for="(item, indexe) in todList"
                @click="tabClick(indexe)">
                {{ $t(item) }}</div>
        </div>

        <div v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" infinite-scroll-distance="10">
            <div class="order-body" v-if="listData && listData.length">

                <div class="list" v-for="item in listData" :key="item.id">
                    <router-link :to="'/agent/detail?member_id=' + item.member_id" v-if="activeTab == 0">
                        <div class="tips-body">
                            <span class="tips">{{ $t('Username') }}: {{ item.member_name }}</span>
                            <span class="tips">ID: {{ item.member_id }}</span>
                            <span class="tips">{{ $t('registration_time') }}: {{ item.member_addtime }}</span>
                            <span class="tips">{{ $t('selling_face_value') }}: {{ item.num }}</span>
                        </div>
                        <div class="ckxq">
                            {{ $t('click_for_details') }}>
                        </div>
                    </router-link>
                    <div v-else>
                        <div class="tips-body">
                            <span class="tips">{{ $t('Username') }}: {{ item.member ? item.member.member_name : '' }}</span>
                            <span class="tips">{{ $t('selling_face_value') }}: {{ item.price }}</span>
                            <span class="tips">{{ $t('Data') }}: {{ item.sale_time }}</span>
                        </div>
                    </div>
                </div>
            </div>
            <empty-record v-else-if="listData && !listData.length"></empty-record>
        </div>

        <mt-popup v-model="boxShow" ref="box" position="bottom" class="box-popup" @touchmove.native.stop.prevent>
            <timeCom @time="time" />
        </mt-popup>
    </div>
</template>

<script>
import { agent_list, agent_gift_list } from '../../../api/memberInviter'
import { Toast, MessageBox, Indicator } from 'mint-ui'
import { mapState } from 'vuex'
import flexLine from '../../flexLine'
import EmptyRecord from '../../../components/EmptyRecord'
import timeCom from './time.vue'
export default {
    components: {
        flexLine,
        EmptyRecord,
        timeCom,
    },
    computed: {
        ...mapState({
            user: state => state.member.info
        }),
        headerStyle() {
            let newOpacity = Math.min(this.maxOpacity, (this.scrollY - this.startChangeAt) / this.opacityMultiplier);
            if (this.scrollY > this.startChangeAt) {
                return { backgroundColor: `rgba(255, 255, 255, ${newOpacity})` };
            } else {
                return { backgroundColor: 'transparent' };
            }
        }
    },
    data() {
        return {
            weixinVisible: false,
            posterVisible: false,
            shareVisible: false,
            copyVisible: false,
            inviter_url: '',
            refer_qrcode_logo: '',
            refer_qrcode_weixin: '',
            wx_error_msg: '',
            wrapperWidth: 0,
            inviter_member: {},
            scrollY: 0,
            startChangeAt: 20, // 开始改变背景色的滚动阈值
            maxOpacity: 1, // 最大不透明度
            opacityMultiplier: 20, // 滚动距离到最大不透明度的倍数
            other: null,
            listData: null,
            times: {
                create_time_start: '',
                create_time_end: ''
            },
            keyword: '', // 关键字
            params: { 'page': 0, 'limit': 10 },
            loading: false, // 是否加载更多
            isMore: true, // 是否有更多
            boxShow: false, //是否显示盲盒奖品弹出层
            todList: ['today', 'this_week', 'this_month', 'last_month', 'this_year'],
            current: -1,
            tabs: [
                {
                    gc_name: 'team_list',
                    type: '0',
                },
                {
                    gc_name: 'GiftCard',
                    type: '1',
                },
            ],
            activeTab: 0,
        }
    },
    created() {
    },
    mounted() {
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll);
    },
    methods: {
        tabClickk(item, index) {
            this.activeTab = index

            this.isMore = true
            this.loadMoreTrue()
        },
        setLang() {
            this.$router.push({ name: 'HomeLang' })
        },
        tabClick(i) {
            if (i == 0) {
                this.selectToday()
            } else if (i == 1) {
                this.selectThisWeek()
            } else if (i == 2) {
                this.selectThisMonth()
            } else if (i == 3) {
                this.selectLastMonth()
            } else if (i == 4) {
                this.selectThisYear()
            } else {
                return
            }

            if (this.current === i) {
                this.current = -1

                this.times.create_time_start = '';
                this.times.create_time_end = '';
            } else {
                this.current = i
            }


            this.getOrderList(true)
        },
        logout() {
            window.localStorage.removeItem('agent_token')
            this.$router.push({ name: 'HomeMemberLogin' })
        },
        time(e) {
            this.times = e
            this.$refs.box.close()
            this.getOrderList(true)
        },
        open() {
            // this.boxShow = true
            this.$refs.box.open()
        },
        loadMore() {
            this.loading = true
            this.params.page = ++this.params.page
            if (this.isMore) {
                this.loading = false
                this.getOrderList(false)
            }
        },
        loadMoreTrue() {
            this.loading = true
            this.params.page = ++this.params.page
            if (this.isMore) {
                this.loading = false
                this.getOrderList(true)
            }
        },
        handleEnter() {
            // if (!this.keyword) return
            this.getOrderList(true)
        },
        getOrderList(ifReplace) {
            let that = this
            Indicator.open()
            if (ifReplace) {
                that.loading = false
                that.params.page = 1
                that.isMore = true
            }

            if (that.activeTab == 0) {

                agent_list(that.params, that.keyword, that.times).then(res => {
                    Indicator.close()
                    if (res.other.currentPage !== res.other.lastPage) {
                        that.isMore = true
                    } else {
                        that.isMore = false
                    }

                    console.log(that.isMore);
                    that.other = res.other
                    // that.listData = res.data

                    let tOrderGroup = res.data

                    if (tOrderGroup) {
                        if (ifReplace || !that.listData) {
                            that.listData = tOrderGroup
                        } else {
                            that.listData = that.listData.concat(tOrderGroup)
                        }
                    }
                }).catch(function (error) {
                    Indicator.close()
                    console.log(error.message)
                })
            } else {
                agent_gift_list(that.params, that.keyword, that.times).then(res => {
                    Indicator.close()
                    if (res.other.currentPage !== res.other.lastPage) {
                        that.isMore = true
                    } else {
                        that.isMore = false
                    }
                    that.other = res.other

                    let tOrderGroup = res.data

                    if (tOrderGroup) {
                        if (ifReplace || !that.listData) {
                            that.listData = tOrderGroup
                        } else {
                            that.listData = that.listData.concat(tOrderGroup)
                        }
                    }
                }).catch(function (error) {
                    Indicator.close()
                    console.log(error.message)
                })
            }
        },
        handleScroll() {
            this.scrollY = window.pageYOffset || document.documentElement.scrollTop;
        },
        copySuccess(sn) {
            this.$copyText(sn).then(
                (e) => {
                    Toast(this.$t('succ'))
                    this.shareVisible = false
                }, (e) => {
                    Toast(this.$t('err'))
                }
            );
        },
        formatDate(date) {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        },
        selectToday() {
            const now = new Date();
            this.times.create_time_start = this.formatDate(now);
            const tomorrow = new Date(now);
            tomorrow.setDate(now.getDate() + 1);
            this.times.create_time_end = this.formatDate(tomorrow);
        },
        selectThisWeek() {
            const now = new Date();
            const startOfWeek = new Date(now.setDate(now.getDate() - now.getDay() + 1)); // 这周一
            const endOfWeek = new Date(now.setDate(now.getDate() - now.getDay() + 8)); // 下周一
            this.times.create_time_start = this.formatDate(startOfWeek);
            this.times.create_time_end = this.formatDate(endOfWeek);
        },
        selectThisMonth() {
            const now = new Date();
            const startOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
            const endOfMonth = new Date(now.getFullYear(), now.getMonth() + 1, 1); // 下月第一天
            this.times.create_time_start = this.formatDate(startOfMonth);
            this.times.create_time_end = this.formatDate(endOfMonth);
        },
        selectLastMonth() {
            const now = new Date();
            const startOfLastMonth = new Date(now.getFullYear(), now.getMonth() - 1, 1);
            const endOfLastMonth = new Date(now.getFullYear(), now.getMonth(), 1); // 本月第一天
            this.times.create_time_start = this.formatDate(startOfLastMonth);
            this.times.create_time_end = this.formatDate(endOfLastMonth);
        },
        selectThisYear() {
            const now = new Date();
            const startOfYear = new Date(now.getFullYear(), 0, 1);
            const endOfYear = new Date(now.getFullYear() + 1, 0, 1); // 明年第一天
            this.times.create_time_start = this.formatDate(startOfYear);
            this.times.create_time_end = this.formatDate(endOfYear);
        },
    }
}
</script>

<style scoped lang="scss">
.tabss {
    padding-left: .7rem;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    padding: 0 .5rem;
    // padding-right: 7.7rem;
    height: 2.5rem;

    .tabb {
        text-align: center;
        font-size: $fontSize;
        color: #333;
        width: 5rem;
        height: 2rem;
        line-height: 2rem;
        text-align: center;
        box-sizing: border-box;
        border-radius: 10px 10px 10px 10px;
        background: #FFFFFF;
        border: 1px solid #CE0901;
    }

    .activee {
        color: #fff;
        background: #CE0901;
    }
}

.lang {
    // position: fixed;
    top: 10px;
    left: 15px;
    z-index: 199;

    img {
        width: 1.5rem;
    }
}

.box-popup {
    border-radius: 20px 20px 0 0;
}

.order-body {
    position: relative;
    padding: .4rem .5rem;

    .list {
        width: 100%;
        padding: .7rem .6rem;
        box-sizing: border-box;
        margin-bottom: 1rem;
        background: #FFFFFF;
        border-radius: 10px 10px 10px 10px;

        .ckxq {
            font-size: 14px;
            color: #CE0901;
            text-align: right;
        }

        .tips-body {
            // height: 2.2rem;
            // background: rgba(255, 255, 255, 1);
            // box-shadow: 0 0.5px 0 0 rgba(232, 234, 237, 1);
            display: flex;
            justify-content: space-between;
            padding: 0 0 .6rem;
            display: grid;
            grid-template-columns: repeat(2, 1fr);

            .tips {
                font-size: .6rem;
                color: #7d7d7d;
                // line-height: 2.2rem;
                font-size: 14px;
                color: #333333;
                margin: 4px;
            }

            .statusTips {
                color: $primaryColor;
            }

            .copy {
                font-weight: 600;
                margin: 0 0;
                font-size: .6rem;
            }

            img {
                width: 3.8rem;
                height: 3rem;
            }
        }

        .order-image {
            // height: 4.55rem;
            // background: rgba(250, 250, 250, 1);
            width: 100%;
            overflow: hidden;
            overflow-x: auto;
            white-space: nowrap;
        }

        .multiple {
            .imagebox {
                width: 100%;
                overflow-x: auto;
                white-space: nowrap;

                img {
                    width: 3rem;
                    height: 3rem;
                    margin: .85rem .3rem .5rem;
                    display: inline-block;
                }
            }
        }

        .number-code {
            font-size: $subFontSize;
            color: rgba(78, 84, 93, 1);
            background-color: #fff;

            .nci {
                height: 2rem;
                padding: 0 .75rem;
                border-bottom: 1px solid #e8eaed;
                display: flex;
                justify-content: space-between;
                align-items: center;

                .tit {
                    margin-bottom: .1rem;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                }

                .cc {
                    padding: 0 .1rem;
                }

                .copy {
                    color: $primaryColor;
                    font-weight: 600;
                }
            }
        }

        .order_amount {
            font-size: $subFontSize;
            color: rgba(78, 84, 93, 1);
            // line-height: 2.2rem;
            // height: 2.2rem;
            // background-color: #fff;
            padding: 0 0.5rem;
            // border-bottom: 1px solid #e8eaed;
            box-sizing: border-box;
            text-align: right;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            display: flex;
            justify-content: flex-end;
            align-items: center;
            color: $primaryColor;
            font-weight: 600;

            .order_amount_icon {
                font-size: $subFontSize;
                color: $primaryColor;
            }

            i {
                font-size: $h2;
                color: $primaryColor;
                padding-left: 0.15rem;
                font-style: normal;

                &.freight {
                    color: #333;
                    font-size: $fontSize;
                }
            }
        }
    }

    .loading-wrapper {
        text-align: center;

        p {
            color: #c3c3c3;
            font-size: $fontSize;
            margin: 0.5rem auto;
        }
    }
}

.tit {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: .5rem 1rem;

    .l {
        font-size: 18px;
        color: #000000;
        font-weight: 600;
    }

    .r {
        font-size: 14px;
        color: #CE0901;
    }
}

.tabs {
    padding: .5rem 1rem;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;

    .tab {
        white-space: nowrap;
        font-size: .6rem;
        color: #7d7d7d;
        font-size: 14px;
        color: #333333;
        padding: .3rem .5rem;
    }

    .active {
        color: #fff;
        border-radius: .4rem;
        background: #E7010C;
    }
}

.search {
    margin: .5rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #fff;
    border-radius: 50px 50px 50px 50px;
    margin: .6rem 1rem;
    padding: .4rem 1rem;

    .l {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .icon {
            width: .7rem;
            height: .7rem;
            margin-right: .3rem;

            img {
                width: 100%;
                height: 100%;
                display: block;
            }
        }
    }

    .search1 {
        // background: #fa2a31;
        border-radius: 10px;
        color: #E7010C;
        // padding: 0 10px;
        font-size: .6rem;
        height: 1.6rem;
        line-height: 1.6rem;
        margin-left: 10px;
    }

    input {
        box-sizing: border-box;
        width: 100%;
        height: 1.6rem;
        border-radius: 10px;
        background-size: 0.55rem;
        font-size: 0.6rem;
        color: #000000;
        background: #fff;
        // padding-left: 1.6rem;
        border: 0;
    }
}

.container {
    min-height: 100vh;
    background-color: #F8F8F8;

    .common-header {
        background: transparent;
        box-shadow: none;
    }

    .center {
        padding: 1rem;
        padding-top: .5rem;
        // background: #FFFFFF;
        border-radius: 25px 25px 0 0;

        .huiyuan {
            background: #A62C22;
            border-radius: 5px 5px 5px 5px;
            padding: 1rem;
            display: flex;
            justify-content: space-around;
            align-items: center;

            .hitem {
                text-align: center;
                color: #FFFFFF;

                .k {
                    color: #D39691;
                    font-size: 14px;
                    margin-bottom: .2rem;
                }

                .v {
                    font-size: 33px;
                    font-weight: 600;
                }
            }
        }

        .goto {
            margin: 1rem 0;
            display: flex;
            justify-content: space-around;
            align-items: center;

            .nav-item {
                width: 49%;
                margin-right: 2%;
                background-color: #e7010c;
                font-size: .6rem;
                text-align: center;
                border-radius: .25rem;
                margin-bottom: .5rem;
                padding: 1rem 0;
                font-size: 12px;
                color: #FFFFFF;
            }
        }
    }
}
</style>
